module.exports = __webpack_public_path__ + "img/mapa_farolito.4a9f6006.svg";